export const i18nKeyPrefix = 'MAIN-CHILD'
